<div class="upgrade-availability">
  <form class="service-form" [formGroup]="reactiveForm" (ngSubmit)="getFlightList()">
    <div class="form-container flex">
      <span class="flex flex-1 locations-wrapper">
        <fin-locations-autocomplete
          class="flex-1 mr-medium-r"
          [parentForm]="reactiveForm"
          [controlName]="'departure'"
          [translationPrefix]="'LOYALTY.upgradeAvailability.departureInput'"
          [inputType]="'text'"
          [options$]="departureLocations$"
          [loading$]="departureLoading$"
        ></fin-locations-autocomplete>
        <fin-locations-autocomplete
          class="flex-1 mr-medium-r"
          [parentForm]="reactiveForm"
          [controlName]="'destination'"
          [translationPrefix]="'LOYALTY.upgradeAvailability.destinationInput'"
          [inputType]="'text'"
          [options$]="destinationLocations$"
          [loading$]="destinationLoading$"
        ></fin-locations-autocomplete>
      </span>
      <fin-datepicker
        class="flex-1"
        [parentForm]="reactiveForm"
        [controlName]="'departureDate'"
        [translationPrefix]="'LOYALTY.upgradeAvailability.departureDateInput'"
        [placeHolder]="'LOYALTY.upgradeAvailability.departureDateInput.placeholder'"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [icon]="SvgLibraryIcon.CALENDAR"
      ></fin-datepicker>
    </div>
    <div class="flex flex--end">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [size]="ButtonSize.LARGE"
        [loading]="formStatus === FormStatus.LOADING"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [text]="'LOYALTY.upgradeAvailability.button' | finLocalization"
      >
      </fcom-button>
    </div>
  </form>
  <div
    *ngIf="selectedDate"
    class="ms-xlarge-t"
    [class.is-vishidden]="(flightList$ | async)?.length <= 0"
    [attr.aria-hidden]="(flightList$ | async)?.length <= 0"
  >
    <fcom-tabs
      [theme]="TabTheme.DEFAULT"
      [align]="'center'"
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      (clickedTab)="getFlightList(dateStringArray[$event.index])"
      #tabs
    >
      <fcom-tab
        *ngFor="let date of dateStringArray"
        [active]="date === selectedDate"
        [title]="date | finDateFormat: 'FULL_NO_YEAR'"
      >
      </fcom-tab>
    </fcom-tabs>
  </div>
  <div *ngIf="formStatus !== FormStatus.ERROR">
    <table
      class="table fill mr-small-t border-bottom"
      [attr.aria-label]="'LOYALTY.upgradeAvailability.table.caption' | finLocalization"
    >
      <thead class="nordic-blue-900-text font-body-1 border-bottom" *ngIf="selectedDate">
        <th class="align-left pr-xsmall-b" scope="col">
          <span>
            {{ 'LOYALTY.upgradeAvailability.table.flight' | finLocalization }}
          </span>
        </th>
        <th class="align-right pr-xsmall-b" scope="col">
          <span>
            {{ 'LOYALTY.upgradeAvailability.table.availability' | finLocalization }}
          </span>
        </th>
      </thead>
      <tbody *ngIf="formStatus === FormStatus.COMPLETE" class="font-body-1 nordic-blue-900-text">
        <ng-container *ngFor="let flight of flightList$ | async">
          <tr
            *ngFor="let segment of flight.list_segment; let i = index"
            [class.border-bottom]="flight.list_segment.length - 1 === i"
          >
            <td
              class="align-left flight-details font-body-1 light-type"
              [ngClass]="{
                'ps-small-t': i === 0,
                'ps-medium-t': i !== 0,
                'ps-small-b': flight.list_segment.length - 1 === i,
              }"
            >
              <span class="pr-large-r">{{ segment.airline_code }}{{ segment.flight_number }}</span>
              <span class="pr-medium-r"
                >{{ 'LOYALTY.upgradeAvailability.table.departure' | finLocalization }}:
                {{ segment.b_location.time }}</span
              >
              <span class="pr-medium-r"
                >{{ 'LOYALTY.upgradeAvailability.table.arrival' | finLocalization }}:
                {{ segment.e_location.time }}</span
              >
            </td>
            <td
              class="align-right font-body-1 medium-type"
              [ngClass]="{
                'pr-xxsmall-t': i === 0,
                'pr-xsmall-t': i !== 0,
                'pr-xxsmall-b': flight.list_segment.length - 1 === i,
              }"
            >
              <span *ngIf="segment.operated_by === 'AY' && segment.available_seats === 1">{{
                'LOYALTY.upgradeAvailability.table.seat' | finLocalization
              }}</span>
              <span
                *ngIf="segment.operated_by === 'AY' && segment.available_seats <= 5 && segment.available_seats > 1"
                >{{
                  'LOYALTY.upgradeAvailability.table.seats' | finLocalization: { seats: segment.available_seats }
                }}</span
              >
              <span *ngIf="segment.operated_by === 'AY' && segment.available_seats > 5"
                >{{ 'LOYALTY.upgradeAvailability.table.moreThan' | finLocalization }}
              </span>
              <span *ngIf="segment.operated_by === 'AY' && segment.available_seats === 0">{{
                'LOYALTY.upgradeAvailability.table.waitlist' | finLocalization
              }}</span>
              <span *ngIf="segment.operated_by !== 'AY'">{{
                'LOYALTY.upgradeAvailability.table.notEligible' | finLocalization
              }}</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot
        *ngIf="formStatus === FormStatus.LOADING"
        aria-live="polite"
        class="align-center ps-small-y font-body-1 medium-type"
      >
        <tr>
          <td class="ps-medium-y" colspan="2">
            <span>
              {{ 'LOYALTY.upgradeAvailability.loading' | finLocalization }}
            </span>
            <fcom-loader class="loader block" [loaderType]="LoaderTheme.INLINE"> </fcom-loader>
          </td>
        </tr>
      </tfoot>
    </table>
    <ng-container *ngIf="(flightList$ | async)?.length > 0">
      <div class="ps-large-y flex flex--end">
        <button
          #openInfoModalButton
          class="font-body-1 underline nordic-blue-900-text block medium-type"
          (click)="openInfoModal($event)"
        >
          <span class="underline">{{ 'LOYALTY.upgradeAvailability.infoModal.button' | finLocalization }}</span>
          <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK"></fcom-icon>
        </button>
      </div>
      <div class="flex flex--end">
        <fcom-button
          [text]="'LOYALTY.upgradeAvailability.startBooking' | finLocalization"
          [size]="ButtonSize.LARGE"
          (clickBtn)="bookNow()"
          [icon]="{
            name: SvgLibraryIcon.EXTERNAL_TAB,
            position: IconPosition.RIGHT,
          }"
        >
        </fcom-button>
      </div>
    </ng-container>
  </div>

  <div *ngIf="formStatus === FormStatus.ERROR" #fcomNotification aria-live="polite">
    <fcom-info-box
      class="pr-small-y pr-clear-t mr-clear block"
      [icon]="SvgLibraryIcon.INFO"
      [text]="errorMessage | finLocalization"
    >
    </fcom-info-box>
  </div>

  <fcom-modal
    [title]="'LOYALTY.upgradeAvailability.infoModal.title' | finLocalization"
    [(open)]="isInfoModalOpen"
    [buttons]="ModalButtons.CLOSE"
    (close)="closeInfoModal()"
  >
    <div class="info-modal ps-large font-body-1 light-type">
      <ul class="ms-large-l">
        <li *ngFor="let item of 'LOYALTY.upgradeAvailability.infoModal.list' | finLocalization">
          <span>{{ item }}</span>
        </li>
      </ul>
      <p class="mr-large-y">
        {{ 'LOYALTY.upgradeAvailability.infoModal.note' | finLocalization }}
      </p>
    </div>
  </fcom-modal>
</div>
